import { render, staticRenderFns } from "./materialCost.vue?vue&type=template&id=1c6686fa&scoped=true&"
import script from "./materialCost.vue?vue&type=script&lang=js&"
export * from "./materialCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6686fa",
  null
  
)

export default component.exports